import React, { useContext } from 'react';
import { useLocation, Link } from 'react-router-dom';
import HeavySetDataContext from '../../context/HeavySetDataContext';
import { setWorkoutTotalReps, urlSlug } from '../../data/helpers';
import { Row, Col } from '../../styles/Grid';
import styled from 'styled-components';
import Card from '../Dashboard/Card';

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 900;
  letter-spacing: -2px;
  text-transform: uppercase;
`;

export const DataTable = styled.table`
  width: 100%;
  margin-top: 1rem;
  margin-bottom: 1rem;
  border-collapse: collapse;
`;

export const DataTableHeader = styled.thead`
  font-size: 1.125rem;
  font-weight: 900;
  letter-spacing: -1px;
  text-transform: uppercase;
  border-bottom: .125rem solid #eceff4;
`;

export const DataTableHeading = styled.th`
  padding: .25rem;
  text-align: left;
`;

export const DataTableBody = styled.tbody`
  text-align: left;

  .DataTableLink {
    color: inherit;
    -webkit-text-decoration-skip: ink;
    text-decoration-skip: ink;

    &:hover {
      color: #a3be8c;
    }
  }
`;

export const DataTableRow = styled.tr`
  border-bottom: .0625rem solid #eceff4;
`;

export const DataTableCell = styled.td`
  padding: .5rem;
  text-align: left;
`;

const SingleWorkout = () => {
  const location = useLocation();
  const { state: { workout }, } = location;
  const data = useContext(HeavySetDataContext);
  const filteredWorkoutData = data.filter(w => w.workout === workout);
  const [lastWorkout] = filteredWorkoutData.slice(-1);
  const frequency = filteredWorkoutData.length;
  const workoutExercises = [...new Set(filteredWorkoutData.map(e => Object.keys(e.exercises)).flat())];
  const totalWorkoutReps = setWorkoutTotalReps(filteredWorkoutData);

  return (
    <>
      <Title>{workout}</Title>

      <Row>
        <Col size={1}>
          <Card>
            <h3 className="Card__title">Workout frequency</h3>
            <div className="Card__data">{frequency}</div>
          </Card>
        </Col>
        <Col size={1}>
          <Card>
            <h3 className="Card__title">Last workout</h3>
            <div className="Card__data">{new Date(lastWorkout.date).toLocaleDateString()}</div>
          </Card>
        </Col>
        <Col size={1}>
          <Card>
            <h3 className="Card__title">Number of exercises</h3>
            <div className="Card__data">{workoutExercises.length}</div>
          </Card>
        </Col>
        <Col size={1}>
          <Card>
            <h3 className="Card__title">Total Rep count</h3>
            <div className="Card__data">{totalWorkoutReps}</div>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col size={1}>
          <Card>
            <h3 className="Card__title">{workout} workout history</h3>
            <DataTable>
              <DataTableHeader>
                <DataTableRow>
                  <DataTableHeading>Date</DataTableHeading>
                  <DataTableHeading>Exercises</DataTableHeading>
                </DataTableRow>
              </DataTableHeader>
              <DataTableBody>
                {
                  filteredWorkoutData.map(row => (
                    <DataTableRow key={row.date}>
                      <DataTableCell>{new Date(row.date).toLocaleDateString()}</DataTableCell>
                      <DataTableCell>{Object.keys(row.exercises).map((exercise, index) => (
                        <React.Fragment key={exercise}>
                          <Link
                            className="DataTableLink"
                            to={{
                              pathname: `/exercises/${urlSlug(exercise)}`,
                              state: { exercise: exercise },
                            }}
                          >
                            {exercise}
                          </Link>
                          {(index === Object.keys(row.exercises).length -1) ? "" : ", "}
                        </React.Fragment>
                      ))}</DataTableCell>
                    </DataTableRow>
                  ))
                }
              </DataTableBody>
            </DataTable>
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default SingleWorkout;
